import React from 'react';

export default function Upload() {
  return <svg width="35" height="42" viewBox="0 0 35 42" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10 17.2941V32.1176H25V17.2941H35L17.5 0L0 17.2941H10ZM17.5 6.91765L23 12.3529H20V27.1765H15V12.3529H12L17.5 6.91765ZM35 37.0588H0V42H35V37.0588Z" fill="white"/>
	</svg>
}
